(function() {
  function waitForAnalytics(callback) {
    if (window.analytics && typeof window.analytics.identify === 'function') {
      callback();
    } else {
      setTimeout(function() {
        waitForAnalytics(callback);
      }, 100);
    }
  }

  function checkConsent() {
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function') {
      return window.Shopify.customerPrivacy.analyticsProcessingAllowed();
    }
    return true;
  }

  function trackUnbounceSubmission(email) {
    if (!email) return;

    if (!checkConsent()) return;

    waitForAnalytics(function() {
      analytics.identify(email, {
        email: email,
        signup_source: 'Unbounce Popup'
      });

      analytics.track('Email Signup Submitted', {
        email: email,
        source: 'Unbounce Popup',
        page: window.location.pathname
      });
    });
  }

  function parseUnbounceData(data) {
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {}
    }

    if (data && data.email) return data.email;
    if (data && data.data && data.data.email) return data.data.email;

    if (data && Array.isArray(data)) {
      const emailField = data.find(function(field) {
        return field.name === 'email' || field.type === 'email';
      });
      if (emailField) return emailField.value;
    }

    return null;
  }

  let processedSubmissions = {};

  window.addEventListener('message', function(event) {
    if (!event.origin || !event.origin.includes('ubembed.com')) return;

    const data = event.data;
    if (!data) return;

    const isSubmission =
      (typeof data === 'object' && (data.type === 'submit' || data.event === 'submit' || data.formSubmit || data.submitted)) ||
      (typeof data === 'string' && (data.includes('submit') || data.includes('form')));

    if (!isSubmission) return;

    const email = parseUnbounceData(data);
    if (!email) return;

    const submissionKey = email + '_' + Date.now();
    const recentSubmission = Object.keys(processedSubmissions).find(function(key) {
      return key.startsWith(email + '_') && (Date.now() - processedSubmissions[key]) < 5000;
    });

    if (recentSubmission) return;

    processedSubmissions[submissionKey] = Date.now();
    trackUnbounceSubmission(email);

    setTimeout(function() {
      delete processedSubmissions[submissionKey];
    }, 10000);
  });

  function tryAccessIframeForm() {
    const iframes = document.querySelectorAll('iframe.ub-emb-iframe');

    iframes.forEach(function(iframe, index) {
      try {
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        if (!iframeDoc) return;

        const form = iframeDoc.querySelector('form');
        if (!form) return;

        form.addEventListener('submit', function(e) {
          const emailInput = form.querySelector('input[type="email"], input[name="email"]');
          const email = emailInput ? emailInput.value : null;
          if (email) trackUnbounceSubmission(email);
        });
      } catch (e) {}
    });
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          const iframe = node.matches('iframe.ub-emb-iframe') ? node : node.querySelector('iframe.ub-emb-iframe');
          if (iframe) {
            iframe.addEventListener('load', function() {
              setTimeout(function() {
                tryAccessIframeForm();
              }, 500);
            });
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(function() {
    tryAccessIframeForm();
  }, 2000);

  let lastUrl = window.location.href;
  let urlCheckInterval = setInterval(function() {
    const currentUrl = window.location.href;
    if (currentUrl !== lastUrl) {
      if (currentUrl.includes('thank') || currentUrl.includes('success') || currentUrl.includes('confirmation')) {
        const urlParams = new URLSearchParams(window.location.search);
        const email = urlParams.get('email') || urlParams.get('e') || sessionStorage.getItem('ubounce_email');
        if (email) {
          trackUnbounceSubmission(email);
          sessionStorage.removeItem('ubounce_email');
        }
      }
      lastUrl = currentUrl;
    }
  }, 500);

  window.addEventListener('beforeunload', function() {
    clearInterval(urlCheckInterval);
  });
})();
